export default __webpack_public_path__ + "static/media/NW0150.34I-36811_-21627_0.1e88d16f.jpg";